export async function fetchJSON(input: RequestInfo, init?: RequestInit) {
  const res = await fetch(input, {
    headers: {
      'Content-Type': 'application/json',
    },
    ...init,
  });

  const json = await res.json();

  if (res.status !== 200) {
    throw new Error(
      `Fetch responded with status ${res.status}: ${JSON.stringify(json)}`
    );
  }

  return json;
}

export async function postContact(body: {
  email: string;
  message: string;
  captchaToken: string;
}) {
  return fetchJSON('/api/contact', {
    method: 'POST',
    body: JSON.stringify(body),
  }) as Promise<null>;
}

export async function postSubscribe(body: {
  email: string;
  captchaToken: string;
}) {
  return fetchJSON('/api/subscribe', {
    method: 'POST',
    body: JSON.stringify(body),
  }) as Promise<null>;
}
